import { render, staticRenderFns } from "./LgameCheckBox.vue?vue&type=template&id=8e47487e&scoped=true"
import script from "./LgameCheckBox.vue?vue&type=script&lang=js"
export * from "./LgameCheckBox.vue?vue&type=script&lang=js"
import style0 from "./LgameCheckBox.vue?vue&type=style&index=0&id=8e47487e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e47487e",
  null
  
)

export default component.exports